import React, { Component } from 'react';
export class Loading extends Component {
    render() {
        return (
            <div>
                <h1>Loading game...</h1>
            </div>
        )
    }
}
